"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'socialMediaPlan.approvalQueue.title': 'Kolejka do akceptacji',
    'socialMediaPlan.approvalQueue.desc': 'Posty czekające na zatwierdzenie przed publikacją',
    'socialMediaPlan.approvalQueue.proposedDate': 'Proponowany termin:',
    'socialMediaPlan.approvalQueue.preview': 'Podgląd',
    'socialMediaPlan.approvalQueue.reject': 'Odrzuć',
    'socialMediaPlan.approvalQueue.approve': 'Zatwierdź',
    'socialMediaPlan.approvalQueue.rejectConfirm': 'Odrzucić ten post i przenieść do szkiców?',
    'socialMediaPlan.approvalQueue.approved': 'Post zatwierdzony do harmonogramu',
    'socialMediaPlan.approvalQueue.rejected': 'Post przeniesiony z powrotem do szkiców',
};
